export default __webpack_public_path__ + "static/media/img-0151-india-half-face.a5313e74.png";